// Feature metadata for landing page and header dropdown

export type FeatureGroup = {
    group: string;
    icon: string; // Placeholder for icon component name or emoji
    features: Array<{
        title: string;
        route: string;
        icon: string; // Placeholder for icon component name or emoji
        description: string;
    }>;
};

export const FEATURE_GROUPS: FeatureGroup[] = [
    {
        group: 'Learn English',
        icon: '📝',
        features: [
            { title: 'Grammar Practice', route: '/grammar', icon: '📚', description: 'Practice grammar topics interactively.' },
            { title: 'Sentence Practice', route: '/sentences', icon: '✍️', description: 'Practice and translate sentences.' },
            { title: 'Word Practice', route: '/dictionary', icon: '🔤', description: 'Practice vocabulary and meanings.' },
            // Conversations button will be added separately in the UI, not as a feature card
        ],
    },
    {
        group: 'AI English Teacher',
        icon: '🤖',
        features: [
            { title: 'Start Learning with AI', route: '/robo-teacher', icon: '🤖', description: 'Interactive AI English tutor with voice recognition and grammar correction.' },
        ],
    },
    {
        group: 'Memorize',
        icon: '🧠',
        features: [
            { title: 'Memorize Grammar', route: '/memorize-grammar', icon: '📖', description: 'Memorize grammar rules and examples.' },
            { title: 'Memorize Sentences', route: '/memorize-sentences', icon: '🗣️', description: 'Memorize useful sentences.' },
            { title: 'Memorize Words', route: '/memorize-words', icon: '📝', description: 'Memorize important words.' },
        ],
    },
    {
        group: 'Favorites',
        icon: '⭐',
        features: [
            { title: 'Favorite Grammar', route: '/favorite-grammar', icon: '🌟', description: 'Your favorite grammar topics.' },
            { title: 'Favorite Sentences', route: '/favorite-sentences', icon: '💬', description: 'Your favorite sentences.' },
            { title: 'Favorite Words', route: '/favorite-words', icon: '❤️', description: 'Your favorite words.' },
        ],
    },
    {
        group: 'Completed',
        icon: '✅',
        features: [
            { title: 'Completed Grammar', route: '/completed-grammar', icon: '✔️', description: 'Grammar topics you have completed.' },
            { title: 'Completed Sentences', route: '/completed-sentences', icon: '📝', description: 'Sentences you have completed.' },
            { title: 'Completed Words', route: '/completed-words', icon: '🏁', description: 'Words you have completed.' },
        ],
    }
]; 